import {ANNOTATOR_FULLSCREEN_TOASTER_ID, ANNOTATOR_PORTAL_ROOT_ID} from '~constants/constants';

export function getAnnotatorFullscreenToasterId(): string | undefined {
  const isAnnotatorFullscreen = Boolean(document.fullscreenElement?.querySelector(`#${ANNOTATOR_PORTAL_ROOT_ID}`));

  return isAnnotatorFullscreen ? ANNOTATOR_FULLSCREEN_TOASTER_ID : undefined;
}
